import React from 'react';
import Modal from '@shared/ui/Modal';
import Button from '@shared/ui/Button';
import CFRecordSections, { CFSection } from './CFRecordSections';
import CommitteeLink from '../committee/CommitteeLink';
import type { Contribution } from '../../types/campaignFinance';
import { fmtMoney, fmtDate, getContributorDisplayName } from '../../utils/campaignFinanceUtils';

interface CFRecordModalProps {
  contribution: Contribution;
  open: boolean;
  onClose: () => void;
}

const CFRecordModal: React.FC<CFRecordModalProps> = ({ contribution, open, onClose }) => {
  const c = contribution;
  const sections: CFSection[] = [
    {
      title: 'Contributor',
      fields: [
        { label: 'Name', value: getContributorDisplayName(c) },
        { label: 'First Name', value: c.contributor_first_name },
        { label: 'Last Name', value: c.contributor_last_name },
        { label: 'Type', value: c.contributor_type },
        { label: 'Employer', value: c.employer },
        { label: 'Occupation', value: c.occupation },
        { label: 'Occupation Notes', value: c.occupation_comments },
      ],
    },
    {
      title: 'Recipient',
      fields: [
        { label: 'Committee', value: c.committee_name ? <CommitteeLink coId={c.co_id} name={c.committee_name} className="text-primary-700 dark:text-primary-dark-400" /> : null },
        { label: 'Committee Type', value: c.committee_type },
        { label: 'Candidate', value: c.candidate_name },
        { label: 'Party', value: c.candidate_party },
        { label: 'Office', value: c.office },
        { label: 'Electioneering', value: c.electioneering },
      ],
    },
    {
      title: 'Transaction',
      fields: [
        { label: 'Amount', value: fmtMoney(c.contribution_amount) },
        { label: 'Date', value: fmtDate(c.contribution_date) },
        { label: 'Type', value: c.contribution_type },
        { label: 'Receipt Type', value: c.receipt_type },
        { label: 'Filed Date', value: c.filed_date ? fmtDate(c.filed_date) : undefined },
        { label: 'Explanation', value: c.explanation },
      ],
    },
    {
      title: 'Record',
      fields: [
        { label: 'CO ID', value: c.co_id },
        { label: 'Record ID', value: c.record_id },
        { label: 'Jurisdiction', value: c.jurisdiction },
        { label: 'Address', value: 'Redacted' },
        { label: 'Amended', value: c.amended ? 'Yes' : 'No' },
        { label: 'Amendment Type', value: c.amendment },
        { label: 'Amended Record ID', value: c.amended_record_id },
        { label: 'Created', value: c.created_at ? fmtDate(c.created_at) : undefined },
        { label: 'Updated', value: c.updated_at ? fmtDate(c.updated_at) : undefined },
      ],
    },
  ];

  return (
    <Modal
      isOpen={open}
      title="Filed record"
      description={`CO-${c.co_id} · Record ${c.record_id}`}
      onClose={onClose}
      size="xl"
      footer={
        <Button variant="secondary" size="sm" onClick={onClose}>
          Close
        </Button>
      }
    >
      <CFRecordSections sections={sections} />
    </Modal>
  );
};

export default CFRecordModal;
